import React from 'react';

export default function VendorLogo(props) {
    const {name} = props;
    if(!name)
        return null;
    const vendorCss = name.toLowerCase().replace(/\s/g, '');
    return <span title={name} className={`vendor-widget vendor-widget-${vendorCss}`} />;
}